import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, firstValueFrom, of } from 'rxjs';
import { catchError, filter, take } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
import { BonusApi } from 'src/app/shared/apis/bonus.api';

@Component({
  selector: 'app-deposit-redirect',
  template: '',
})
export class DepositRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private appService: AppService,
    private bonusApi: BonusApi,
  ) {}

  async ngOnInit() {
    const queryParams = { ...this.route.snapshot.queryParams };
    const bonusCode = queryParams.bonuscode || queryParams.bonusCode || queryParams.activityId;

    if (bonusCode && !queryParams.currency && !queryParams.type) {
      const [bonusInfo, currencies, currentCurrency] = await firstValueFrom(
        combineLatest([
          this.bonusApi.getDepositBonusInfo({ bonusCode }).pipe(catchError(() => of(null))),
          this.appService.currencies$.pipe(
            filter(currencies => currencies.length > 0),
            take(1),
          ),
          this.appService.currentCurrency$.pipe(filter(Boolean), take(1)),
        ]),
      );

      const selectedCurrencyCode =
        bonusInfo?.currencies?.find(item => item.currency === currentCurrency.currency)?.currency ||
        bonusInfo?.currencies?.[0]?.currency ||
        currentCurrency.currency;
      const selectedCurrency =
        currencies.find(currency => currency.currency === selectedCurrencyCode && currency.isVisible) ||
        currentCurrency;

      queryParams.currency = selectedCurrency.currency;
      queryParams.type = selectedCurrency.isDigital ? 'd-crypto' : 'd-fiat';
      queryParams.bonuscode = bonusInfo?.bonusCode || bonusCode;
      delete queryParams.bonusCode;
    }

    this.router.navigate([this.appService.languageCode], {
      queryParams,
      fragment: 'wallet',
      replaceUrl: true,
    });
  }
}
